import { Button } from '@/components/button'
import { EventItem } from '@/components/common'
import { MainContent } from '@/components/content'
import { ArrowBack } from '@/components/icons'
import { MainLayout } from '@/components/layouts'
import { MainSidebar, MobileSidebar } from '@/components/sidebar'
import { EventItemLoading } from '@/components/skeleton'
import { LIMIT, OFFSET, SCROLLING_HEIGHT_ABS_ERROR, SCROLLING_THROTTLING_DURATION } from '@/constants/Common'
import { ROUTE_PLAY } from '@/constants/Routes'
import { useAppDispatch, useAppSelector } from '@/hooks/useRedux'
import { appSelector } from '@/pages/home/selectors'
import { throttle } from 'lodash'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { getMyEvents } from '../eventSlice'
import { eventSelector } from '../selectors'

export const MyEvents = () => {
  const { t } = useTranslation()

  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const { isShowDropdown } = useAppSelector(appSelector)
  const { resMyEvents, isLoadingMyEvents } = useAppSelector(eventSelector)

  const [offset, setOffset] = useState(OFFSET)

  const handleScroll = throttle(() => {
    if (
      Math.abs(window.innerHeight + document.documentElement.scrollTop - document.documentElement.offsetHeight) >
      SCROLLING_HEIGHT_ABS_ERROR
    ) {
      return
    }

    setOffset((pre) => pre + LIMIT)
  }, SCROLLING_THROTTLING_DURATION)

  const handleBackToEvents = () =>
    navigate(ROUTE_PLAY, {
      state: {
        goBackEvent: true,
      },
    })

  const onGetMyEvents = () => {
    dispatch(
      getMyEvents({
        limit: 10,
        offset: offset,
      })
    )
  }

  useEffect(() => {
    onGetMyEvents()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [offset])

  useEffect(() => {
    if (resMyEvents.hasMore) window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resMyEvents])

  return (
    <>
      {!isShowDropdown && <MobileSidebar />}
      <MainLayout>
        <MainSidebar />
        <MainContent>
          <div className="flex flex-col gap-y-4 mb-20 lg:mb-8">
            <div className="flex items-center">
              <Button onClick={handleBackToEvents} className="hover:opacity-50">
                <ArrowBack className="text-white" />
              </Button>
              <h1 className="ml-3 text-sm md:text-xl text-white font-semibold">{t('event.myEvents')}</h1>
            </div>

            {resMyEvents?.hits?.map((item) => <EventItem key={item.leagueId} event={item} />)}
            {isLoadingMyEvents && (
              <>
                <EventItemLoading className="mt-3" />
                <EventItemLoading className="mt-3" />
                <EventItemLoading className="mt-3" />
                <EventItemLoading className="mt-3" />
                <EventItemLoading className="mt-3" />
              </>
            )}
            {resMyEvents && !resMyEvents?.hasMore && (
              <div className="flex justify-center mt-4">
                <span className="text-white font-semibold text-opacity-60">{t('common.noMoreResults')}</span>
              </div>
            )}
          </div>
        </MainContent>
      </MainLayout>
    </>
  )
}
